module.exports = __webpack_public_path__ + "static/email-6dfd7925bc6ecca0f5fafca0bd868776.png";